/**
 * @generated SignedSource<<d77a2e179c39bd4dfd8299bc2341538d>>
 * @relayHash c863ef1f892b5519a3dde9a98bdd3d5b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f78dddfdf8be1f6fba3407eb9053f566e4222e1b943a1d8c6ee9123158902875

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventScreenSettingsButtonCopyEventMutation$variables = {
  eventId: string;
};
export type EventScreenSettingsButtonCopyEventMutation$data = {
  readonly copyEvent: {
    readonly event: {
      readonly prettyUrl: string;
    } | null | undefined;
  };
};
export type EventScreenSettingsButtonCopyEventMutation = {
  response: EventScreenSettingsButtonCopyEventMutation$data;
  variables: EventScreenSettingsButtonCopyEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScreenSettingsButtonCopyEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyEventMutationPayload",
        "kind": "LinkedField",
        "name": "copyEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventScreenSettingsButtonCopyEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyEventMutationPayload",
        "kind": "LinkedField",
        "name": "copyEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f78dddfdf8be1f6fba3407eb9053f566e4222e1b943a1d8c6ee9123158902875",
    "metadata": {},
    "name": "EventScreenSettingsButtonCopyEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "145d26f908a39c35c357fec605bf1894";

export default node;
